import { useState, useEffect } from 'react';
import logo from '../../../assets/images/learn41.png';

const navLinks = [
  { label: "Who It's For", href: '#who-its-for' },
  { label: 'Try It', href: '#try-interview' },
  { label: 'Join Community', href: '#join-community' },
];

function scrollTo(e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>, id: string) {
  e.preventDefault();
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
}

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [visible, setVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const currentY = window.scrollY;
      if (currentY < 50) {
        setVisible(true);
      } else if (currentY > lastScrollY) {
        setVisible(false);
        setMenuOpen(false);
      } else {
        setVisible(true);
      }
      setLastScrollY(currentY);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [lastScrollY]);

  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 px-4 sm:px-6 pt-3 transition-transform duration-300"
      style={{ transform: visible ? 'translateY(0)' : 'translateY(-100%)' }}
    >
      <nav className="max-w-7xl mx-auto bg-white/50 backdrop-blur-xl rounded-full border border-white/40 shadow-lg shadow-black/5">
        <div className="relative px-6 sm:px-8 flex items-center justify-between" style={{ height: '52px' }}>
          <img src={logo} alt="Learn41" className="h-7 shrink-0" />

          {/* Desktop links, centered */}
          <div className="hidden md:flex items-center gap-7 absolute left-1/2 -translate-x-1/2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollTo(e, link.href.slice(1))}
                className="text-sm text-gray-800 hover:text-gray-950 font-medium transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* CTA, right side */}
          <a
            href="#book-demo"
            onClick={(e) => scrollTo(e, 'book-demo')}
            className="hidden md:flex items-center bg-gray-900 text-white font-semibold text-sm px-6 rounded-full hover:bg-gray-800 transition-colors shrink-0"
            style={{ height: '40px' }}
          >
            Book a Call
          </a>

          {/* Mobile hamburger */}
          <button
            className="md:hidden text-gray-900"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              {menuOpen ? (
                <>
                  <line x1="6" y1="6" x2="16" y2="16" />
                  <line x1="6" y1="16" x2="16" y2="6" />
                </>
              ) : (
                <>
                  <line x1="4" y1="6" x2="18" y2="6" />
                  <line x1="4" y1="11" x2="18" y2="11" />
                  <line x1="4" y1="16" x2="18" y2="16" />
                </>
              )}
            </svg>
          </button>
        </div>

        {/* Mobile dropdown */}
        {menuOpen && (
          <div className="md:hidden px-6 pb-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  scrollTo(e, link.href.slice(1));
                  setMenuOpen(false);
                }}
                className="block py-3 text-gray-500 hover:text-gray-900 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#book-demo"
              onClick={(e) => {
                scrollTo(e, 'book-demo');
                setMenuOpen(false);
              }}
              className="block mt-2 text-center bg-gray-900 text-white font-semibold text-sm px-5 py-2 rounded-full"
            >
              Book a Call
            </a>
          </div>
        )}
      </nav>
    </div>
  );
}
